import styled, { keyframes } from 'styled-components';

const appearFromTop = keyframes`
  from {
    opacity: 0;
    transform: translateY(-50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const appearFromBottom = keyframes`
  from {
    opacity: 0;
    transform: translateY(50px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
`;

const appearFromLeft = keyframes`
  from {
    opacity: 0;
    transform: translateX(-50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

const appearFromRight = keyframes`
  from {
    opacity: 0;
    transform: translateX(50px);
  }
  to {
    opacity: 1;
    transform: translateX(0);
  }
`;

export const Container = styled.div`
  flex: 1;
  display: flex;
  flex-direction: column;
  padding: 2rem 3.5rem;

  @media (max-width: 769px) {
    padding: 1rem;
  }

  .alert {
    background: #f1f1f1;
    padding: 20px;
    font-weight: 500;
    text-align: center;
    color: #333;
    border-radius: 5px;
  }

  .chart-box {
    height: 18.75rem;
  }
`;

export const TopBlocks = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  margin-bottom: 2rem;
  flex-wrap: wrap;

  .block {
    background-color: #fff;
    width: calc(100% / 4 - 1.5rem);
    height: 11rem;
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: 5px;
    padding: 0 1.5rem;

    animation: ${appearFromTop} 1s;
    text-align: center;

    &:nth-child(2n + 1) {
      animation: ${appearFromBottom} 1s;
    }

    @media (max-width: 1024px) {
      width: calc(100% / 2 - 10px);
      margin-top: 20px;
      height: 9rem;
    }

    h2 {
      color: var(--primaryColor);
      font-size: 3rem;
      line-height: 1.7;
    }

    h4 {
      color: var(--primaryColor);
      font-size: 1.25rem;
    }

    h6 {
      color: #c2c2c2;
    }

    div:nth-child(1) {
      flex: 1;
    }

    .image {
      height: 70px;
      width: 70px;
      margin-left: 20px;
      background: #e9edf5;
      border-radius: 40px;
      padding: 15px;

      img {
        width: 100%;
      }
    }

    .loading {
      flex: 1;
      display: flex;
      justify-content: center;
      align-items: center;
      flex-direction: column;

      .h2 {
        background: #e2e2e2;
        width: 60px;
        height: 40px;
        margin-bottom: 15px;
        animation: shine 1s ease-in-out infinite;
        animation-fill-mode: forwards;
      }

      .h4 {
        background: #e2e2e2;
        width: 230px;
        max-width: 90%;
        height: 24px;
        animation: shine 1s ease-in-out infinite;
        animation-fill-mode: forwards;
      }

      .h6 {
        background: #e2e2e2;
        width: 180px;
        max-width: 80%;
        height: 18px;
        animation: shine 1s ease-in-out infinite;
        animation-fill-mode: forwards;
      }
    }
  }
`;


export const LineChart = styled.div`
  background: #fff;
  border-radius: 5px;
  overflow: hidden;
  width: 100%;
  display: flex;
  flex-direction: column;
  padding: 1.75rem;
  animation: ${appearFromBottom} 1s;

  h4 {
    color: var(--primaryColor);
    font-size: 1rem;
  }

  .loading {
    .h2 {
      background: #e2e2e2;
      width: 60px;
      height: 40px;
      margin-bottom: 15px;
      animation: shine 1s ease-in-out infinite;
      animation-fill-mode: forwards;
    }

    .chart {
      height: 300px;
      width: 100%;
      background: #e2e2e2;
    }
  }
`;
